<template>
    <div class="directions-item">
        <div class="direction-content" @click="direct" :class="showDirection ? 'active' : ''">
            <h3>{{ data.title }}</h3>
            <div class="plus" v-if="!showDirection">
                <img class="plus"
                     src="../assets/images/accordion_plus.png"
                     alt="">
            </div>
            <div class="minus" v-if="showDirection">
                <img src="../assets/images/accordion_minus.png" alt="">
            </div>
        </div>

        <transition name="fadeHeight">
            <div class="collapsed-content" v-if="showDirection" :class="showDirection ? 'show' : ''">
                <div class="collapsed-image">
                    <img :src="data.logo ? data.logo.full_size : ''" :alt="data.title">
                </div>
                <div v-html="data.short_description" class="collapsed-desc">
                </div>
                <router-link tag="div" :to="{name: 'departmentDetail', params:{slug: data.slug}}"
                             class="collapsed-button">
                    Подробная информация →
                </router-link>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: ["data", "showDirection"],
    data() {
        return {}
    },
    methods: {
        direct() {
            this.$emit("direct", this.data.title)
        }
    }
}
</script>

<style scoped>

.directions {
    width: 30%;
    margin-left: 25px;
}

.directions-item {
    /*width: 100%;*/
    border-bottom: 1px solid #E0E0E0;
}

.directions-content {
    margin-top: 20px;
}

.direction-content.active {
    background-color: #006688;
    color: #fff;
    padding: 12px 13px 12px 12px;
}

.direction-content:not(.active):hover h3 {
    color: #006688;
}

.direction-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    width: 100%;
    text-align: left;
    font-size: 13px;
    padding: 12px 13px 12px 0;
    background: transparent;
    color: #666;
    font-weight: 400;
}

.collapsed-image {
    margin: 10px 0;
    display: flex;
}


.collapsed-content .minus {

}


.collapsed-desc {
    padding: 1em 0;
    color: #666;
    text-align: left;
    font-size: 13px;
}

.collapsed-image img {
    width: 30%;
}

.collapsed-button {
    color: #58b9da;
    width: 230px;
    padding: 10px 14px;
    border: 2px solid #58b9da;
    margin-bottom: 20px;
    background-color: transparent;
    font-size: 13px;
    cursor: pointer;
}

.collapsed-button:hover {
    background-color: #58b9da;
    color: #fff;
}

.fadeHeight-enter-active,
.fadeHeight-leave-active {
    transition: .2s ease;
    max-height: 340px;
    opacity: 1;
}

.fadeHeight-enter,
.fadeHeight-leave-to {
    opacity: 0;
    max-height: 0;
}
</style>